import { Chip } from "@mui/material"
import type { FC } from "react"

import { formatDate } from "@/utils/date"

interface ProductInventoryTransactionDateChipProps {
  date?: string | null
}

export const ProductInventoryTransactionDateChip: FC<ProductInventoryTransactionDateChipProps> = ({ date }) => {
  if (!date) return null

  return <Chip className='h-6 rounded bg-gray-300 text-xs' label={formatDate(date)} />
}
